// extracted by mini-css-extract-plugin
module.exports = {"pagination":"guides-module--pagination--2yIeF","link":"guides-module--link--1YLQG"};